import type {Variants} from 'motion/react';

export const MenuBase: Variants = {
    closed: {},
    desktop: {},
    desktopClosed: {},
    initial: {},
    open: {}
};

export const PathOne: Variants = {
    closed: {
        strokeDasharray: '24 111.22813415527344',
        strokeDashoffset: -50.22813415527344,
        transition: {duration: 0.8},
        x: '0px'
    },
    desktop: {
        strokeDasharray: '24 111.22813415527344',
        strokeDashoffset: -50.22813415527344,
        transition: {duration: 0},
        x: '0px'
    },
    desktopClosed: {
        strokeDasharray: '24 111.22813415527344',
        strokeDashoffset: -50.22813415527344,
        transition: {duration: 0},
        x: '0px'
    },
    initial: {
        strokeDasharray: '24 111.22813415527344',
        strokeDashoffset: -50.22813415527344,
        transition: {duration: 0.8},
        x: '0px'
    },
    open: {
        strokeDasharray: '22.627416998 111.22813415527344',
        strokeDashoffset: -16.9705627485,
        transition: {duration: 0.8},
        x: '30px'
    }
};

export const PathTwo: Variants = {
    closed: {
        strokeDasharray: '24 99',
        strokeDashoffset: -38,
        transition: {duration: 0.8},
        x: '0px'
    },
    desktop: {
        strokeDasharray: '24 99',
        strokeDashoffset: -38,
        transition: {duration: 0},
        x: '0px'
    },
    desktopClosed: {
        strokeDasharray: '24 99',
        strokeDashoffset: -38,
        transition: {duration: 0},
        x: '0px'
    },
    initial: {
        strokeDasharray: '24 99',
        strokeDashoffset: -38,
        transition: {duration: 0.8},
        x: '0px'
    },
    open: {
        strokeDasharray: '0 99',
        strokeDashoffset: -20,
        transition: {duration: 0.8},
        x: '30px'
    }
};

export const MenuTransitions: Variants = {
    closed: {
        transition: {duration: 0.8},
        x: '120%'
    },
    desktop: {
        transition: {duration: 0},
        x: '0%'
    },
    desktopClosed: {
        transition: {duration: 0},
        x: '120%'
    },
    initial: {
        transition: {duration: 0.8},
        x: '120%'
    },
    open: {
        transition: {duration: 0.8},
        x: '0%'
    }
};